import React, { lazy } from "react";

const ErrorPage = lazy(() => import("../pages/error-page"))
const TwoDD = lazy(() => import("../pages/phonic_sound/parent"))
const GameList = lazy(() => import("../pages/phonic_sound/game-list"))
const IdentifyColours = lazy(() => import("../pages/identify-colour/parent"))
const Parent2 = lazy(() => import("../pages/identify-colour/parent-2"))
const DragMesh = lazy(() => import("../pages/Trial/trialMesh"));


const ThreeJSCanvas = lazy(()=>import("../pages/identify-colous/trial"))


export const RoutesList = [
    {
        layout: <ErrorPage />,
        path: '/error',
        name: 'Error Page',
        isAuthProtected: true,
    },
    {
        layout: <GameList />,
        path: '/',
        name: 'Game List',
        isAuthProtected: true,
    },
    {
        layout: <TwoDD />,
        path: '/game-play-1',
        name: 'Parent Page',
        isAuthProtected: true,
    },
    {
        layout: <TwoDD />,
        path: '/game-play-2',
        name: 'Parent Page',
        isAuthProtected: true,
    },
    {
        layout: <TwoDD />,
        path: '/game-play-3',
        name: 'Parent Page',
        isAuthProtected: true,
    },
    {
        layout: <TwoDD />,
        path: '/game-play-4',
        name: 'Parent Page',
        isAuthProtected: true,
    },
    {
        layout: <TwoDD />,
        path: '/game-play-5',
        name: 'Parent Page',
        isAuthProtected: true,
    },
    {
        layout: <TwoDD />,
        path: '/game-play-6',
        name: 'Parent Page',
        isAuthProtected: true,
    },
    {
        layout: <TwoDD />,
        path: '/game-play-7',
        name: 'Parent Page',
        isAuthProtected: true,
    },
    {
        layout: <TwoDD />,
        path: '/game-play-8',
        name: 'Parent Page',
        isAuthProtected: true,
    },
    {
        layout: <TwoDD />,
        path: '/game-play-9',
        name: 'Parent Page',
        isAuthProtected: true,
    },
    {
        layout: <TwoDD />,
        path: '/game-play-10',
        name: 'Parent Page',
        isAuthProtected: true,
    },
    {
        layout: <TwoDD />,
        path: '/game-play-11',
        name: 'Parent Page',
        isAuthProtected: true,
    },
    {
        layout: <TwoDD />,
        path: '/game-play-12',
        name: 'Parent Page',
        isAuthProtected: true,
    },
    {
        layout: <IdentifyColours />,
        path: '/identify-colour',
        name: 'Identify colour Page',
        isAuthProtected: true,
    },
    {
        layout: <Parent2 />,
        path: '/identify-colour-2',
        name: 'Identify colour Page',
        isAuthProtected: true,
    },
    {
        layout: <DragMesh />,
        path: "/drag",
        name: "DragMesh",
        isAuthProtected: true
    },
    {
        layout: <ThreeJSCanvas />,
        path: '/identify-colour-3',
        name: 'Identify colour Page',
        isAuthProtected: true,
    }

];

export const openRoutes = [
    {
        layout: <ErrorPage />,
        path: '/error',
        name: 'Error Page',
        isAuthProtected: false,
    },

];
